const navRoutes = {
    'reading-property-maintenance': 'reading-property-maintenance',
    'caversham-property-maintenance': 'caversham-property-maintenance',
    'earley-property-maintenance': 'earley-property-maintenance',
    'tilehurst-property-maintenance': 'tilehurst-property-maintenance',
    'whitley-property-maintenance': 'whitley-property-maintenance',
    'winnersh-property-maintenance': 'winnersh-property-maintenance',
    'woodley-property-maintenance': 'woodley-property-maintenance',
    'shinfield-property-maintenance': 'shinfield-property-maintenance',
    'twyford-property-maintenance': 'twyford-property-maintenance',
    'wokingham-property-maintenance': 'wokingham-property-maintenance',
    'calcot-property-maintenance': 'calcot-property-maintenance',
    'sonning-property-maintenance': 'sonning-property-maintenance',
    'pangbourne-property-maintenance': 'pangbourne-property-maintenance',
    'theale-property-maintenance': 'theale-property-maintenance',
    'lower-earley-property-maintenance': 'lower-earley-property-maintenance',
    'purley-on-thames-property-maintenance': 'purley-on-thames-property-maintenance',
    'arborfield-property-maintenance': 'arborfield-property-maintenance',
    'finchampstead-property-maintenance': 'finchampstead-property-maintenance',
    'burghfield-property-maintenance': 'burghfield-property-maintenance',
    'spencers-wood-property-maintenance': 'spencers-wood-property-maintenance',
    'wargrave-property-maintenance': 'wargrave-property-maintenance',
    'swallowfield-property-maintenance': 'swallowfield-property-maintenance',
    'hungerford-property-maintenance': 'hungerford-property-maintenance',
    'newbury-property-maintenance': 'newbury-property-maintenance',
    'thatcham-property-maintenance': 'thatcham-property-maintenance',
    'bracknell-property-maintenance': 'bracknell-property-maintenance',
    'crowthorne-property-maintenance': 'crowthorne-property-maintenance',
    'binfield-property-maintenance': 'binfield-property-maintenance',
    'sandhurst-property-maintenance': 'sandhurst-property-maintenance',
    'yateley-property-maintenance': 'yateley-property-maintenance',
    'basingstoke-property-maintenance': 'basingstoke-property-maintenance',
    'aldermaston-property-maintenance': 'aldermaston-property-maintenance',
    'barkham-property-maintenance': 'barkham-property-maintenance',
    'grazeley-property-maintenance': 'grazeley-property-maintenance',
    'stratfield-mortimer-property-maintenance': 'stratfield-mortimer-property-maintenance',
    'sulhamstead-property-maintenance': 'sulhamstead-property-maintenance',
    'tadley-property-maintenance': 'tadley-property-maintenance',
    'woolhampton-property-maintenance': 'woolhampton-property-maintenance',
    'beenham-property-maintenance': 'beenham-property-maintenance',
    'stanford-dingley-property-maintenance': 'stanford-dingley-property-maintenance',
    'englefield-property-maintenance': 'englefield-property-maintenance',
    'farnborough-property-maintenance': 'farnborough-property-maintenance',
    'hook-property-maintenance': 'hook-property-maintenance',
    'hartley-wintney-property-maintenance': 'hartley-wintney-property-maintenance',
    'riseley-property-maintenance': 'riseley-property-maintenance',
    'burghfield-common-property-maintenance': 'burghfield-common-property-maintenance',
    'padworth-property-maintenance': 'padworth-property-maintenance',
    'whitchurch-on-thames-property-maintenance': 'whitchurch-on-thames-property-maintenance'
};

module.exports = navRoutes;
